<template>
  <div class="homepage">
    <div class="tutor-recommend section" name="tutor">
      <div class="section-title">
        导师计划
        <div class="bar" />
      </div>
      <div class="content">
        <div v-for="(item, index) in tutorList" :key="index" class="content-item" :class="{marginLeft: index !== 0}">
          <img :src="item.headImg ? $urlPrefix + item.headImg : require('../../assets/img/defaultHead2.png')" alt="">
          <span @click="checkDetails(1,item.pkid)">{{ item.tutorName }}</span>
          <div class="tutor-details">&nbsp;&nbsp;{{ item.tutorProfile }}</div>
        </div>
      </div>
      <div class="check-all" @click="handleCheckAll(1)">
        查看全部
      </div>
    </div>
    <div class="theme section" name="theme">
      <div class="section-title">
        主题分堂
      </div>
      <div class="theme-type">
        <div
          v-for="item in themeTypeList"
          :key="item.id"
          class="theme-type-item"
          :class="{on: activeType === item.id || hoverType === item.id}"
          @click="activeType = item.id"
          @mouseenter="hoverType = item.id"
          @mouseleave="hoverType = ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="content">
        <div v-for="(item,index) in themeContentList[themeTypeList[activeType-1].code]" :key="index" class="content-item" :class="{marginLeft30: index%2 === 1}">
          <div v-if="item.process" class="enroll" :style="{backgroundColor: $processMapping[item.process].color}">{{ $processMapping[item.process].name }}</div>
          <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
          <div v-else class="coverArea">
            <p>{{ item.type === 'activity' ? item.activityTitle : item.specialTitle }}</p>
          </div>
          <div class="details">
            <div :style="{backgroundColor: item.type === 'activity' ? $typeColorMapping[item.activityType] : $typeColorMapping[item.specialType]}">
              {{ item.type === 'activity' ? $typeMapping[item.activityType] : $typeMapping[item.specialType] }}
            </div>
            <span class="title" @click="checkDetails(2, item.pkid, item.type)">{{ item.type === 'activity' ? item.activityTitle : item.specialTitle }}</span>
            <br>
            <p v-if="item.type === 'activity'">活动时间：{{ item.startTime }}</p>
            <p v-else>主讲人：{{ item.keynoteSpeaker }}</p>
            <span class="price-span">
              <template v-if="item.originPrice">
                <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                  <span class="old-price">￥{{ item.originPrice }}元/人</span>
                  <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                </template>
                <span v-else>￥{{ item.originPrice }}元/人</span>
              </template>
              <span v-else>免费</span>
            </span>
            <div class="check-details" @click="checkDetails(2, item.pkid, item.type)">查看详情</div>
          </div>
        </div>
        <div class="check-all" @click="handleCheckAll(2)">
          查看全部
        </div>
      </div>
    </div>

    <div class="specialty section" name="specialty">
      <div class="section-title">
        专业活动
        <div class="bar" />
      </div>
      <div class="content">
        <div v-for="count in 5" class="content-text" :key="count" :class="'content-item' + count" @click="toSpecialty(count)">
          <span>{{ textList[count - 1] }}</span>
        </div>
      </div>
    </div>
    <div class="course section">
      <el-carousel height="300px" style="width: 1200px;margin: 0 auto; overflow: hidden" type="card" arrow="always" indicator-position="none">
        <el-carousel-item v-for="(item, index) in courseList" :key="index">
          <img :src="$urlPrefix + item.coverImg" alt="" @click="checkDetails(3, item.pkid, item.type)">
          <div class="bottom-title"><span>{{ item.specialTitle }}</span></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="information section" name="information">
      <div class="section-title">
        学堂资讯
        <div class="bar" />
      </div>
      <div v-for="(item, index) in informationList" :key="index" class="information-item">
        <img :src="$urlPrefix + item.coverImg" alt="">
        <div class="content">
          <div class="title">
            <span @click="checkDetails(4, item.pkid)">{{ item.infoTitle }}</span>
          </div>
          <span class="time">{{ item.releaseTime }}</span>
          <div class="description">{{ item.societyProfile }}</div>
        </div>
      </div>
      <div class="check-all" @click="handleCheckAll(3)">
        查看全部
      </div>
    </div>

    <div class="floatNavi">
      <el-timeline>
        <el-timeline-item
          v-for="item in naviList"
          :key="item.name"
          :class="{active: activeNode === item.name}"
          :color="activeNode === item.name ? '#EA5504' : ''"
        >
          <p @click="jump(item.name)">{{ item.label }}</p>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      textList: ['汇聚云端的融资课堂', '企业成长的培训营地', '企业问诊的定制沙龙', '连接资本的创业秀场', '资本共盈的巅峰论道'],
      naviList: [
        {
          name: 'tutor',
          label: '导师计划'
        },
        {
          name: 'theme',
          label: '主题分堂'
        },
        {
          name: 'specialty',
          label: '专业活动'
        },
        {
          name: 'information',
          label: '学堂资讯'
        }
      ],
      activeNode: 'tutor',
      informationList: [],
      courseList: [],
      themeContentList: {},
      activeType: 1,
      hoverType: '',
      themeTypeList: [
        {
          id: 1,
          name: '产品研习堂',
          code: 'product'
        },
        {
          id: 2,
          name: '运维能力课',
          code: 'operation'
        },
        {
          id: 3,
          name: '资本对接营',
          code: 'capital'
        }
      ],
      tutorList: []
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const theme = document.getElementsByName('theme')[0].offsetTop - 300
      const specialty = document.getElementsByName('specialty')[0].offsetTop - 300
      const information = document.getElementsByName('information')[0].offsetTop - 300
      if (scrollTop < theme) {
        this.activeNode = 'tutor'
      } else if (scrollTop >= theme && scrollTop < specialty) {
        this.activeNode = 'theme'
      } else if (scrollTop >= specialty && scrollTop < information) {
        this.activeNode = 'specialty'
      } else if (scrollTop >= information) {
        this.activeNode = 'information'
      }
    },
    toSpecialty(count) {
      this.$router.push({
        path: '/specialty',
        query: {
          type: count
        }
      })
    },
    jump(location) {
      const topH1 = document.getElementsByName(location)[0]
      document.documentElement.scrollTop = topH1.offsetTop
      window.pageYOffset = topH1.offsetTop
      document.body.scrollTop = topH1.offsetTop
      this.activeNode = location
    },
    fetchData() {
      this.$get('/front/index/data').then(res => {
        if (res) {
          this.$emit('changeBannerList', res.banner)
          this.tutorList = res.tutor
          this.courseList = res.special
          this.informationList = res.society
          Object.keys(res.themeSociety).forEach(key => {
            this.$emit('getActivityProcess', res.themeSociety[key].activityList)
            res.themeSociety[key].activityList.forEach(activity => {
              activity.type = 'activity'
            })
            res.themeSociety[key].courseList.forEach(course => {
              course.type = 'course'
            })
            this.themeContentList[key] = [...res.themeSociety[key].activityList, ...res.themeSociety[key].courseList]
          })
        }
      })
    },
    checkDetails(type, id, flag) {
      let path = ''
      const pathList = JSON.stringify([
        {
          name: '首页',
          path: '/homepage'
        }
      ])
      if (type === 1) {
        this.$router.push({
          path: '/tutorDetail',
          query: {
            pkid: id,
            pathList: pathList
          }
        })
      } else if (type === 2) {
        flag === 'activity' ? path = '/activityDetail' : path = '/courseMain'
        this.$router.push({
          path: path,
          query: {
            pkid: id,
            pathList: pathList
          }
        })
      } else if (type === 3) {
        flag === 'specialActivity' ? path = '/activityMain' : path = '/courseMain'
        this.$router.push({
          path: path,
          query: {
            pkid: id,
            pathList: pathList
          }
        })
      } else if (type === 4) {
        this.$router.push({
          path: '/informationDetail',
          query: {
            pkid: id,
            pathList: pathList
          }
        })
      }
    },
    handleCheckAll(type) {
      if (type === 1) {
        this.$emit('cleanActivePath')
        this.$router.push('/tutor')
      } else if (type === 2) {
        this.$emit('cleanActivePath')
        this.$router.push('/' + this.themeTypeList[this.activeType - 1].code)
      } else if (type === 3) {
        this.$router.push({
          path: '/informationMain',
          query: {
            pathList: JSON.stringify([
              {
                name: '首页',
                path: '/homepage'
              }
            ])
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homepage {
  width: 100%;
  background-color: #FEFEFE;
  text-align: center;
  .floatNavi {
    position: fixed;
    top: 53%;
    right: 20px;
    width: 110px;
    padding-left: 5px;
    z-index: 999;
    overflow: hidden;
    p {
      height: 23px;
      cursor: pointer;
      font-size: 15px;
    }
    p:hover {
      color: #EA5504;
      font-size: 16px;
      font-weight: 600;
    }
    .active {
      P {
        color: #EA5504;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .section {
    width: 100%;
    padding: 30px 0;
    background-color: #F6F6F6;
    margin: 0 auto;
    .section-title {
      width: 100%;
      height: 78px;
      font-size: 48px;
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .bar {
      width: 40px;
      height: 3px;
      background: #EA5504;
      margin: 15px auto 0 auto;
    }
    .check-all {
      width: 160px;
      height: 50px;
      line-height: 50px;
      background: #EA5504;
      border-radius: 5px;
      color: #FFFFFF;
      margin: 30px auto 0 auto;
      cursor: pointer;
      font-size: 18px;
    }
    .check-all:hover {
      opacity: 0.9;
    }
  }
  .tutor-recommend {
    .content {
      width: 1200px;
      height: 363px;
      margin: 30px auto 0 auto;
      .content-item {
        display: inline-block;
        width: 218px;
        height: 363px;
        background: #ffffff;
        border-radius: 5px;
        img {
          width: 218px;
          height: 218px;
          margin-bottom: 15px;
        }
        span {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          cursor: pointer;
        }
        span:hover {
          color: #EA5504;
        }
        p {
          padding: 10px 5px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
        }
        .tutor-details {
          width: 218px;
          height: 85px;
          margin-top: 5px;
          padding: 0 10px;
          box-sizing: border-box;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          overflow: hidden;
          text-align: left;
        }
      }
      .content-item:hover {
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
      }
      .marginLeft {
        margin-left: 27px;
      }
    }
  }
  .theme {
    background-color: #EFF0F0;
    .theme-type {
      width: 100%;
      height: 68px;
      border-top: 1px solid #DCDCDC;
      border-bottom: 1px solid #DCDCDC;
      .theme-type-item.on {
        background: #EA5504;
        color: #ffffff;
      }
      .theme-type-item {
        display: inline-block;
        width: 160px;
        height: 68px;
        line-height: 68px;
        font-size: 24px;
        margin: 0 auto;
        cursor: pointer;
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      .content-item {
        position: relative;
        display: inline-block;
        width: 585px;
        height: 180px;
        margin-top: 30px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 15px 20px;
        box-sizing: border-box;
        overflow: hidden;
        .enroll {
          position: absolute;
          top: -31px;
          right: -31px;
          width: 63px;
          height: 63px;
          background-color: #0AC18F;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 109px;
          transform: rotate(45deg);
          z-index: 10;
        }
        img {
          display: inline-block;
          width: 210px;
          height: 150px;
          border-radius: 5px;
        }
        .details {
          display: inline-block;
          position: relative;
          width: 305px;
          height: 150px;
          margin-left: 30px;
          vertical-align: top;
          text-align: left;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
          font-size: 14px;
          div {
            display: inline-block;
            width: 80px;
            height: 24px;
            background: #F69F60;
            border-radius: 5px;
            text-align: center;
            margin-right: 10px;
            color: #FFFFFF;
          }
          .title {
            cursor: pointer;
          }
          .title:hover {
            color: #EA5504;
          }
          p {
            width: 100%;
            padding-top: 15px;
            color: #999999;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .price-span {
            position: absolute;
            left: 0;
            bottom: -5px;
            .old-price {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              text-decoration: line-through;
              margin-right: 5px
            }
            span {
              color: #EF2727;
              font-size: 16px;
              font-weight: bold
            }
          }
          .check-details {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 108px;
            height: 30px;
            line-height: 30px;
            background: #EA5504;
            border-radius: 2px;
            text-align: center;
            cursor: pointer;
          }
          .check-details:hover {
            opacity: 0.9;
          }
        }
      }
      .content-item:hover {
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
      }
      .marginLeft30 {
        margin-left: 30px;
      }
    }
  }
  .specialty {
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 30px auto;
      div {
        position: relative;
        width: 218px;
        height: 110px;
        span {
          position: absolute;
          bottom: 10px;
          right: 20px;
          font-size: 13px;
          color: #FFFFFF;
        }
      }
      div:hover{
        transform: scale(1.08);
      }
      .content-item1 {
        background: url('../../assets/img/zaiyingduan.png') bottom center no-repeat;
        span {
          bottom: 5px;
        }
      }
      .content-item2 {
        background: url('../../assets/img/peixunying.png') bottom center no-repeat;
        span {
          right: 23px;
          bottom: 8px;
        }
      }
      .content-item3 {
        background: url('../../assets/img/yingxianghui.png') bottom center no-repeat;
        span {
          right: 23px;
          bottom: 6px;
        }
      }
      .content-item4 {
        background: url('../../assets/img/weiluyan.png') bottom center no-repeat;
        span {
          right: 25px;
          bottom: 6px;
        }
      }
      .content-item5 {
        background: url('../../assets/img/yingfenglun.png') bottom center no-repeat;
      }
    }
  }
  .course {
    background-color: #EFF0F0;
    img {
      width: 100%;
      height: 300px;
      border-radius: 10px;
    }
    .bottom-title {
      position: absolute;
      width: 100%;
      height: 50px;
      padding: 0 20px;
      line-height: 50px;
      font-size: 24px;
      color: #FFFFFF;
      background: rgba(51, 51, 51, 0.3);
      border-radius: 10px;
      bottom: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span {
        opacity: 1;
      }
    }
  }
  .information {
    .information-item {
      margin: 20px auto 0 auto;
      width: 1200px;
      height: 164px;
      background: #FFFFFF;
      border-radius: 5px;
      padding: 20px;
      box-sizing: border-box;
      img {
        width: 200px;
        height: 124px;
        border-radius: 5px;
        display: inline-block;
      }
      .content {
        width: 940px;
        margin-left: 20px;
        display: inline-block;
        vertical-align: top;
        height: 124px;
        text-align: left;
        .title {
          font-size: 24px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis ;
          white-space: nowrap;
          color: #333333;
          margin-bottom: 15px;
          span {
            cursor: pointer;
          }
          span:hover {
            color: #EA5504;
          }
        }
        .time {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .description {
          margin-top: 5px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis ;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
        }
      }
    }
    .information-item:hover {
      box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
    }
  }
}

</style>
